//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            keyword: this.value || '',
        }
    },
    watch: {
        value (latest, old) {
            if (latest !== old) {
                this.keyword = latest
            }
        },
        keyword (latest) {
            if (latest !== this.value) {
                this.$emit("input", latest)
            }
        },
    },
    methods: {
        resetKeyword () {
            this.keyword = ""
        },
        changeSelected(type) {
            this.$emit('changeSelected', type)
        },
        onSubmit() {
            this.$emit('submit', this.keyword)
        },
        onConfirm(value) {
            this.$emit('confirm', value)
        }
    },
    props: {
        "show-loading": Boolean,
        "selects-options": Array,
        "selected-item": String,
        "show-location": Boolean,
        "show-share": Boolean,
        "disabled": Boolean,
        "placeholder": String,
        "share-log": String,
        "location-log": String,
        "show-selects": Boolean,
        "share-type": {
            type: String,
            default: "black",
            validator (value) {
                const themes = ["black", "white", "primary"]
                return value && themes.includes(value)
            }
        },
        "theme": {
            type: String,
            default: "white",
            validator (value) {
                const themes = ["white", "grey"]
                return value && themes.includes(value)
            }
        },
        "show-search": Boolean,
        "auto-focus": Boolean,
        value: {
            type: String,
            default: ''
        },
        "confirm-type": {
            type: String,
            default: ''
        }
    }
}
